export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4790.b5499b54.jpg";